export function createLevelsArray(maxLevel: number, minLevel: number): number[] {
  return Array.from({ length: maxLevel - minLevel + 1 }, (_, index) => index + minLevel);
}
